import Helpers from "../utils/helpers";
import fitVids from "fitvids";
import LazyLoad from "vanilla-lazyload";
import Swiper, { Lazy, Navigation, Thumbs } from "swiper";

const Common = {
  init() {
    new LazyLoad();

    Common.events();
    Common.search();
    Common.accordions();
    Common.videoPlay();
    Common.gallerySimple();
    Common.checkboxHandler();
    Common.progressBar();
  },

  events() {
    // Table
    $(".entry-content table").wrap(
      '<div class="scrolltable"><div class="scrolltable__inner"></div></div>'
    );
    $(".scrolltable").scroll(function () {
      $(this).addClass("scrolled");
    });

    // Fitvids
    fitVids();
  },

  search() {
    $("#searchsubmit").on("click", function (e) {
      e.preventDefault();

      if (Helpers.validate($(this), false)) {
        $("#searchform").submit();
      }
    });
  },

  accordions() {
    var header = "accordion__header";
    var header_class = "." + header;
    var header_active = header + "--open";

    $("body").on("click", header_class, function () {
      var btn = $(this);
      var siblings = btn.parent().siblings();

      // Show content
      btn.next().slideToggle(250);

      // Close siblings
      siblings.children(header_class).removeClass(header_active);
      siblings.children(".accordion__body").slideUp(250);

      // Scroll to dropdown
      if (!btn.hasClass(header_active)) {
        setTimeout(function () {
          var scrollTo = btn.offset().top - $(".main").offset().top;
          $("html, body").animate(
            {
              scrollTop: scrollTo - $(".header").height() - 20,
            },
            250
          );
        }, 250);
      }

      // Animate header
      btn.toggleClass(header_active);
    });
  },

  videoPlay() {
    $(".js-play-video").on("click", function () {
      var videoWrapper = $(this).closest(".video");
      var videoElement = videoWrapper.find("video")[0];

      if (videoWrapper.hasClass("playing")) {
        videoWrapper.removeClass("playing");
        videoElement.pause();
      } else {
        videoWrapper.addClass("playing");
        videoElement.play();
      }
    });
  },

  gallerySimple() {
    const wrapEl = $(".gallery-block");
    if (!wrapEl.length) {
      return;
    }

    const thumbsSliderEl = wrapEl.find(".thumbs-slider");
    const gallerySliderEl = wrapEl.find(".large-slider");

    var thumbsSwiper = new Swiper(thumbsSliderEl[0], {
      spaceBetween: 8,
      slidesPerView: 2,
      freeMode: true,
      watchSlidesProgress: true,
      breakpoints: {
        600: {
          slidesPerView: 3,
        },
      },
    });

    var largeSwiper = new Swiper(gallerySliderEl[0], {
      modules: [Lazy, Navigation, Thumbs],
      slidesPerView: 1,
      spaceBetween: 16,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1,
      },
      navigation: {
        prevEl: wrapEl.find(".slider-nav__btn-prev")[0],
        nextEl: wrapEl.find(".slider-nav__btn-next")[0],
      },
      thumbs: {
        swiper: thumbsSwiper,
      },
    });
  },

  checkboxHandler() {
    $(".field--checkbox .checkbox .checkbox__inner").on("click", (e) => {
      let $input = $(e.target).siblings("input");
      $input.prop("checked", !$input.prop("checked")).trigger("change");
    });
  },

  progressBar() {
    document.addEventListener('DOMContentLoaded', function () {
      const bars = document.querySelectorAll('.progress__bar');
      bars.forEach((bar) => {
        let progress = parseFloat(bar.getAttribute("data-progress")) * 100;
        bar.style.width = `${progress}%`;
      })
    }
    )
  }

};

export default Common;
